import MenuIcon from "@mui/icons-material/Menu";
import {
  Box,
  Button,
  IconButton,
  Link,
  Stack,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/styles";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import Logo from "src/components/Logo";
import LanguagePopover from "src/components/dashboard/LanguagePopover";
import Container from "../Container";
import AuthAside from "./AuthAside";
import DesktopNavbar from "./DesktopNavbar";
import MobileSidebar from "./MobileSidebar";

const langIconMap = {
  br: "/static/icons/pt_flag.png",
  en: "/static/icons/uk_flag.svg",
  es: "/static/icons/es_flag.svg",
};

export const Header: FC = () => {
  const { t, i18n } = useTranslation(["langs", "home", "menu"]);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  const menu = [
    { label: t("menu:start_investing"), href: "#home-hero" },
    { label: t("menu:benefits"), href: "#benefits-section" },
    { label: t("menu:how_to_operate"), href: "#steps-section" },
    { label: t("menu:faq"), href: "#faq-section" },
  ];

  return (
    <>
      <AuthAside onClose={() => navigate("/")} />
      <MobileSidebar
        menu={menu}
        open={mobileDrawerOpen}
        onOpen={() => setMobileDrawerOpen(true)}
        onClose={() => setMobileDrawerOpen(false)}
      />
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 9,
          backgroundColor: "#00060A",
        }}
      >
        <Container
          sx={{
            display: "flex",
            alignItems: "center",
            height: 72,
          }}
        >
          <Link component={RouterLink} to="/" sx={{ mr: "auto" }}>
            <Logo sx={{ height: 24 }} />
          </Link>
          {!isMobile && <DesktopNavbar menu={menu} />}
          <Stack direction="row" spacing={isMobile ? 1 : 2} sx={{ ml: "auto" }}>
            {!isMobile && (
             <LanguagePopover />
            )}
            <Button
              variant="text"
              size={isMobile ? "medium" : "large"}
              onClick={() => {
                navigate("/login");
              }}
            >
              {t("home:login")}
            </Button>
            <Button
              variant="contained"
              size={isMobile ? "medium" : "large"}
              onClick={() => {
                navigate("/register");
              }}
            >
              {t("home:register")}
            </Button>
          </Stack>
          {isMobile && (
            <Box sx={{ ml: 1 }}>
              <IconButton
                color="inherit"
                aria-label="open menu drawer"
                edge="end"
                onClick={() => setMobileDrawerOpen(true)}
              >
                <MenuIcon fontSize="large" />
              </IconButton>
            </Box>
          )}
        </Container>
      </Box>
    </>
  );
};
